import { Injectable } from '@angular/core';
import { CanActivateChild, ActivatedRouteSnapshot, RouterStateSnapshot, Router, UrlTree } from '@angular/router';
import { select, Store } from '@ngrx/store';
import { Observable, of } from 'rxjs';
import { mergeMap,  take } from 'rxjs/operators';
import { IAuthState } from 'src/modules/authentication/+store/auth.state';
import { getUserInfo } from 'src/modules/authentication/+store/auth-selector';
import { LocalStorageService } from 'src/modules/shared/services/local-storage.service';

@Injectable({
    providedIn: 'root'
})
export class LoggedInGuard implements CanActivateChild {

    constructor(
        private readonly store: Store<IAuthState>,
        private router: Router,
        private localStorageService: LocalStorageService
    ) { }

    canActivateChild(childRoute: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean | UrlTree>  {
        // Extract and store teamCode if present in URL (for team invitation flow)
        const teamCode = childRoute.queryParams['teamCode'];
        if (teamCode) {
          this.localStorageService.setSingleKey('teamCode', teamCode).then(() => {
            console.log('Team code stored in localStorage:', teamCode);
          });
        }

        return this.store
        .pipe(select(getUserInfo))
        .pipe(take(1))
        .pipe(
          mergeMap( user =>{
            if(user){
              return of(true)
            }
            // User is not Logged In
            // Preserve the intended URL and query params
            const returnUrl = state.url;
            return of(this.router.parseUrl(`/auth/login?returnUrl=${encodeURIComponent(returnUrl)}`))
          })
        )
    }


    
    
}